module.exports = __webpack_public_path__ + "static/media/image4.12cb2ed0.png";